import { getRootDoc } from "front-end-helpers"

const RootDoc = getRootDoc<MU_RootDocument["RootDocument"]>()
export default RootDoc
